import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";

interface IProps {
    className?: string;
    onUpClick?: () => void;
    onDownClick?: () => void;
}

export const ReelNavigationButtons = (props: IProps) => {
    const handleUpClick = () => {
        props.onUpClick?.();
    };

    const handleDownClick = () => {
        props.onDownClick?.();
    };

    return (
        <div css={wrapperStyle} className={props.className}>
            <Button type="button" variant="filled_primary" onClick={handleUpClick} css={buttonGeneralStyle}>
                <ChevronUpIcon size="3.6" />
            </Button>
            <Button type="button" variant="filled_primary" onClick={handleDownClick} css={buttonGeneralStyle}>
                <ChevronDownIcon size="3.6" />
            </Button>
        </div>
    );
};

const wrapperStyle = css`
    ${flex()};
    flex-direction: column;
    gap: ${calculateRemSize(2)};
`;

const buttonGeneralStyle = css`
    ${flexAbsoluteCenter};
    width: ${calculateRemSize(8)};
    height: ${calculateRemSize(8)};
    min-width: auto;
    min-height: auto;
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";

interface IProps {
    className?: string;
    onUpClick?: () => void;
    onDownClick?: () => void;
}

export const ReelNavigationButtons = (props: IProps) => {
    const handleUpClick = () => {
        props.onUpClick?.();
    };

    const handleDownClick = () => {
        props.onDownClick?.();
    };

    return (
        <div css={wrapperStyle} className={props.className}>
            <Button type="button" variant="filled_primary" onClick={handleUpClick} css={buttonGeneralStyle}>
                <ChevronUpIcon size="3.6" />
            </Button>
            <Button type="button" variant="filled_primary" onClick={handleDownClick} css={buttonGeneralStyle}>
                <ChevronDownIcon size="3.6" />
            </Button>
        </div>
    );
};

const wrapperStyle = css`
    ${flex()};
    flex-direction: column;
    gap: ${calculateRemSize(2)};
`;

const buttonGeneralStyle = css`
    ${flexAbsoluteCenter};
    width: ${calculateRemSize(8)};
    height: ${calculateRemSize(8)};
    min-width: auto;
    min-height: auto;
`;
